module.exports = __webpack_public_path__ + "img/plaque.1062855d.png";